/*
 * Copyright (c) 2019
 *    Reliant Business Valuation, LLC - http://reliantvalue.com
 *    Author: Ronnel Bedana - ronnel@internalvaluation.com
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import {Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { Franchise } from 'src/app/model';
import {FranchiseProvider } from 'src/app/providers';
import { CrmAlertComponent } from '../../fields';
import Quill from 'quill';
import BlotFormatter from 'quill-blot-formatter';
Quill.register('modules/blotFormatter', BlotFormatter);

@Component({
  selector: 'create-new-franchise-modal',
  templateUrl: './create-new-franchise.modal.html',
  styleUrls: ['./create-new-franchise.modal.scss']
})

export class CreateNewFranchiseModal implements OnInit, OnDestroy {
  @ViewChild('alert') alert: CrmAlertComponent;
	subject: Subject<Franchise>;
  subscription: any;
  isEdit = false;
  franchise: Franchise = new Franchise();
  isLoading:boolean= false
  quillModules = {
    blotFormatter: {},
    toolbar: [
    [{ 'align': null}, {'align': 'center'}, {'align': 'right'}, {'align': 'justify'}],
    ['bold', 'italic', 'underline', 'strike'],
    [{ 'color': [] }, { 'background': [] }],
    [{ 'list': 'ordered'}, { 'list': 'bullet' }],
    [{ 'indent': '-1'}, { 'indent': '+1' }],
    ['link', 'image'],
    ['clean'],
    ]
    };

  constructor(
    public bsModalRef: BsModalRef,
    private modalService: BsModalService,
    private router: Router,
    private franchiseProvider: FranchiseProvider
  ) { }

  ngOnInit(): void {
    // Fix for when user clicks `ESC` instead of clicking, no Event was firing
    this.subscription = this.modalService.onHide.subscribe((reason: string) => {
      if (reason === 'esc')
        this.onCancel();
    });
  }

  ngOnDestroy(): void {
    if (this.subscription)
      this.subscription.unsubscribe();
  }

  onSubmit(): void {
    this.isLoading=true;
    this.alert.hide();
    if(this.isEdit){
      this.franchiseProvider.updateFranchise(this.franchise)
      .subscribe(
        data => {
          if (data.success) {
            this.isLoading=false;
            this.bsModalRef.hide();
            this.subject.complete();
          }
          else {
            this.isLoading=false;
            this.alert.showError(data.error.txt)
          }
        });
    }
    else{
      this.franchiseProvider.addFranchise(this.franchise)
      .subscribe(
        data => {
          if (data.success) {
            this.isLoading=false;
            this.bsModalRef.hide();
            this.subject.next(Franchise.parse(data.result));
            this.subject.complete();
          }
          else {
            this.isLoading=false;
            this.alert.showError(data.error.txt)
          }
        });
    }
  }
    

  onCancel(): void {
    this.bsModalRef.hide();
    this.subject.complete();
  }
}
